import merge from 'lodash/merge';
import {forwardRef, useImperativeHandle, useRef} from 'react';
import {WebImageWithApngFallbackProps} from './WebImageWithApngFallbackProps.interface';
import {WebpImageElement} from './WepImageElement.interface';

export const WebpImageWithApngFallback = forwardRef<
  WebpImageElement | null,
  WebImageWithApngFallbackProps
>(
  (
    {
      imageUrl,
      apngUrl,
      width,
      height,
      isIos,
      alt = '',
      isWebp,
      style,
      ...props
    },
    ref
  ) => {
    const imageRef = useRef<WebpImageElement>(null);
    useImperativeHandle<
      WebpImageElement | null,
      WebpImageElement | null
    >(ref, () => {
      if (!imageRef.current) {
        return null;
      }
      imageRef.current.replay = () => {
        if (!imageRef.current) {
          return;
        }
        // 이미지 src를 초기화하는 방식으로 이미지를 다시 불러와서 이미지 애니메이션을 다시 동작시킨다.
        // webp는 src를 사용하지 않지만 이미지를 다시 로드하면서 source태그의 srcSet을 먼저 사용하는 것을 확인함
        const source = imageRef.current.src;
        imageRef.current.src = '';
        imageRef.current.src = source;
      };
      return imageRef.current;
    }, []);

    // webp가 아닌 경우 일반 img태그 반환
    if (!isWebp) {
      return (
        <img
          src={imageUrl}
          ref={imageRef}
          alt={alt}
          style={merge(
            {
              width,
              height,
            },
            style
          )}
          {...props}
        />
      );
    }
    return (
      <picture style={{width, height}}>
        {
          /* webp 지원 가능한 경우 이 source element의 srcSet으로 img를 그림.
    ios14는 webp를 지원하지만 애니메이션일 경우 하얀색 배경이 깜빡거리고, 약간 깨지는 현상이 있어서 ios는 모두 apng를 보여줌 */
          !isIos && <source srcSet={imageUrl} type="image/webp" />
        }
        <img
          // webp가 지원 불가능한 경우 apng를 사용해서 img를 그림
          src={apngUrl}
          ref={imageRef}
          alt={alt}
          style={merge(
            {
              width,
              height,
            },
            style
          )}
          {...props}
        />
      </picture>
    );
  }
);
